export default "__VITE_ASSET__DfMUyQhU__"